/**
 * store
 */

import { configureStore } from '@reduxjs/toolkit';
import { api } from '@sqke/report-render';
import appReducer from '@/slices/app';
import { apiSlice } from '@/slices/api';
import dataAnalysisSlice from '@/pages/OldFiles/Tool/DataAnalysisTool/store';

const store = configureStore({
  // 将多个切片整合
  reducer: {
    app: appReducer,
    dataAnalysis: dataAnalysisSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => (
    getDefaultMiddleware().concat(apiSlice.middleware, api.middleware)
  ),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: {},
});

export default store;
